<div class="container">
  <div class="upper-row">
    <span *ngIf="descriptionText.length > 0" class="desc">
      {{descriptionText + ' '}}
    </span>
    <span class="button" [ngClass]="{'disabled-button': disabledButton}" (click)="buttonClick()">
      {{buttonText}}
    </span>
  </div>
  <div *ngIf="disabledButton && displayCountdown" class="countdown">
    {{countDown}} {{countdownMsg}}
  </div>
</div>